export const frB = {
  perfs: {
    noPerf: 'Aucune performance',
    result: 'Résultat :',
    nbVictories: 'Victoires :',
    team: 'Équipe :',
    nbDefeats: 'Défaites :',
    totalScore: 'Score total :',
    top1: 'Top 1 :',
    top3: 'Top 3 :',
    topHalf: 'Top middle :',
    finalPlace: 'Position finale :',
  },
  homeMercatoSection: {
    titlePlayer: 'JOUEURS',
    titleStructure: 'STRUCTURES',
  },
  homeCertifLabel: 'Obtiens ton badge gamer certifié',
  homeSearchMercatoLabel: 'Tu recherches une équipe, ou un joueur ?',
  homeSearchMercatoLabel2nd: 'La section mercato est faite pour toi !',
  goToPageEvent: "Voir l'événement",
  goToParamEvent: 'Paramètres',
  myEvents: {
    pageTitle: 'Mes événements',
    noContent: {
      HANDLED: 'Aucun événement géré',
      REGISTERED: "Vous n'êtes inscris à aucun événement",
      FINISHED: 'Aucun événement terminés',
    },
    tabs: {
      handled: 'Gérés',
      registered: 'Inscris',
      terminated: 'Terminés',
    },
    createEvent: 'Créer un événement',
    searchEvents: "S'inscrire à un événement",
  },
  eventNotBegun: "L'événement n'a pas encore commencé",
  homeUpDescription: {},
  mercatoTabs: {
    structures: 'Rechercher des structures',
    players: 'Rechercher des joueurs',
  },
};
